import { FormGroup } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { Base } from "./Base";

export class FormlyView extends Base {
    public form: FormGroup;
    public fields: FormlyFieldConfig[];
    public model = {};

    constructor(   
        form: FormGroup = new FormGroup({}),
        fields: FormlyFieldConfig[] = [],
        model: {} = {}
    ) {
        super();
        this.form = form;
        this.fields = fields;
        this.model = model;
        this.valid = true;
        }

}